// extracted by mini-css-extract-plugin
export default {"spacer":"mainMenu_spacer__3ozdO","infoCard":"mainMenu_infoCard__GWYDf"};